const PROCESS_PRIORITY = [
	{
		label: "Máquinário",
		value: "MACHINERY",
	},
	{
		label: "Projeto",
		value: "PROJECT",
	},
	{
		label: "Alto Valor",
		value: "HIGH_VALUE",
	},
];

export default PROCESS_PRIORITY;
